
export default function EthicsSection() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div>
          {/* Left Column - Studio Ethics */}
          <div>
            <h2 className="text-3xl font-bold text-[#00889D] mb-8">Studio Ethics</h2>

            <div className="space-y-8">
              <div>
                <h3 className="text-xl font-bold text-[#00889D] mb-3">Arriving on Time</h3>
                <p className="text-gray-700 leading-relaxed">
                  We kindly ask that you arrive at least 5–10 minutes before class begins.
                  To protect the safety and integrity of our members’ practice, late arrivals 
                  will not be admitted once class has started.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-bold text-[#00889D] mb-3">Booking Your Class</h3>
                <p className="text-gray-700 leading-relaxed">
                  We recommend signing up before attending class to ensure your spot, but our team is always happy to help you with registration at the studio. If you've pre-registered, please check in upon arrival at the front desk.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-bold text-[#00889D] mb-3">Equipment & Props</h3>
                <p className="text-gray-700 leading-relaxed">
                  All essential props — including bolsters, blocks, and straps — are available for you to use at no extra cost. Yoga mats can be rented for $5 per class or are included free with certain types of membership or you're welcome to use your mat. Please sanitise all props after use and return them to their designated place, including rental mats.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-bold text-[#00889D] mb-3">Class & Workshop Cancellation Policy</h3>
                <p className="text-gray-700 leading-relaxed">
                  You may cancel your reservation up to 4 hours before class by 
                  signing in to your account on the website to avoid a Late Cancellation 
                  or No-Show fee.
                  For workshops and events please <a href="mailto:info@yogaseven.com" className="text-[#00889D] underline">email</a> more than 3 days prior to the event for cancellation. No refunds less than 3 days prior to the event.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-bold text-[#00889D] mb-3">Be Ready For Class</h3>
                <p className="text-gray-700 leading-relaxed">
                  Please bring your yoga mat and water bottle (a refill station is available onsite). If you need a rental mat, allow yourself a little extra time before class begins.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-bold text-[#00889D] mb-3">We Start & Finish Class Together</h3>
                <p className="text-gray-700 leading-relaxed">
                  Please be ready to begin class on time and remain in the room until class 
                    is complete.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-bold text-[#00889D] mb-3">Class Time is a Phone-free Zone</h3>
                <p className="text-gray-700 leading-relaxed">
                 Find space to disconnect and leave your phone behind.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-bold text-[#00889D] mb-3">Class Room is a Fragrance-free Zone</h3>
                <p className="text-gray-700 leading-relaxed">
               For the comfort of all clients, please avoid wearing strong perfumes, colognes, or scented products.
                </p>
              </div>

              <div>
                <h3 className="text-xl font-bold text-[#00889D] mb-3">Clean Space</h3>
                <p className="text-gray-700 leading-relaxed">
               Please remove your shoes at the entrance and place them in the cubbies provided — no footwear is permitted inside the yoga room.
                </p>
              </div>

              
            </div>
          </div>

          {/* Right Column - Our Values */}
          <div className="grid">
            <h2 className="text-3xl font-bold text-[#00889D] mb-8 pt-16">Our Values</h2>

            <div className="grid md:grid-cols-3 gap-10">
              <div className="bg-[#F6F1EF] p-6 shadow-lg rounded-3xl">
                <h3 className="font-bold text-[#00889D] mb-2">Inclusive & Welcoming:</h3>
                <p className="text-gray-700 text-sm">All bodies, identities, ages, and abilities are respected and valued.</p>
              </div>

              <div className="bg-[#F6F1EF] p-6 shadow-lg rounded-3xl">
                <h3 className="font-bold text-[#00889D] mb-2">Safety First:</h3>
                <p className="text-gray-700 text-sm">Teachers stay within ethical scope and prioritise student well-being.</p>
              </div>

              <div className="bg-[#F6F1EF] p-6 shadow-lg rounded-3xl">
                <h3 className="font-bold text-[#00889D] mb-2">Consent Matters:</h3>
                <p className="text-gray-700 text-sm">Any hands-on support is always optional and based on clear consent.</p>
              </div>

              <div className="bg-[#F6F1EF] p-6 shadow-lg rounded-3xl">
                <h3 className="font-bold text-[#00889D] mb-2">Professional & Qualified:</h3>
                <p className="text-gray-700 text-sm">Our team upholds integrity, competence, and ongoing education.</p>
              </div>

              <div className="bg-[#F6F1EF] p-6 shadow-lg rounded-3xl">
                <h3 className="font-bold text-[#00889D] mb-2">Privacy Protected:</h3>
                <p className="text-gray-700 text-sm">Personal information and conversations are kept confidential.</p>
              </div>

              <div className="bg-[#F6F1EF] p-6 shadow-lg rounded-3xl">
                <h3 className="font-bold text-[#00889D] mb-2">Clean & Cared for:</h3>
                <p className="text-gray-700 text-sm">Studios and equipment are maintained to the highest hygiene standards.</p>
              </div>

              <div className="bg-[#F6F1EF] p-6 shadow-lg rounded-3xl">
                <h3 className="font-bold text-[#00889D] mb-2">Trauma-informed:</h3>
                <p className="text-gray-700 text-sm">We offer choice and safety for participants of all experiences.</p>
              </div>

              <div className="bg-[#F6F1EF] p-6 shadow-lg rounded-3xl">
                <h3 className="font-bold text-[#00889D] mb-2">Culturally Respectful:</h3>
                <p className="text-gray-700 text-sm">We honour yoga's roots and teach with inclusivity and awareness.</p>
              </div>

              <div className="bg-[#F6F1EF] p-6 shadow-lg rounded-3xl">
                <h3 className="font-bold text-[#00889D] mb-2">Community-minded:</h3>
                <p className="text-gray-700 text-sm">We foster kindness, sustainability, and local connection.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
